import { render, staticRenderFns } from "./Applying.vue?vue&type=template&id=0c31e652&scoped=true&"
import script from "./Applying.vue?vue&type=script&lang=js&"
export * from "./Applying.vue?vue&type=script&lang=js&"
import style0 from "./Applying.vue?vue&type=style&index=0&id=0c31e652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31e652",
  null
  
)

export default component.exports